"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm1 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.415 5a1.5 1.5 0 0 0-2.83 0H6.5A1.5 1.5 0 0 0 5 6.5v12A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 17.5 5zM12 5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m0 2a1.5 1.5 0 0 0 1.415-1H15v1.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V6h1.585A1.5 1.5 0 0 0 12 7M6.5 6H8v1.5A1.5 1.5 0 0 0 9.5 9h5A1.5 1.5 0 0 0 16 7.5V6h1.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5"
  })]
}), 'Register');
//# sourceMappingURL=index.js.map